import { React , useState } from 'react';
import { Link } from 'react-router-dom'

import item from '../../assets/fake-data/item';

const About = () => {

    const [data] = useState(
        {
            subtitle: 'About me',
            title: 'Full Service Creative',
            desc1: 'Here is my secret, great work starts with a great attitude.',
            desc2: 'When you are relaxed and having fun, it shows. When you trust the process, magic happens. When you work with someone who has mastered the technical stuff so completely that it becomes invisible, that is when you get content that delights and surprises.',
        }
    )

    return (
        <section className="tf-section section-about">
            <div className="container">
                <div className="row reverse">
                    <div className="col-xl-7 col-md-12">
                        <div className="group-image">
                            <div className="left">
                                <div className="item bg-1"><img src={item.gif1} alt="Monteno" /></div>
                            </div>
                            <div className="right">
                                <div className="item bg-2"><img src={item.gif2} alt="Monteno" /></div>
                                <div className="item bg-2"><img src={item.item9} alt="Monteno" /></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5 col-md-12">
                        <div className="block-text pt-12">
                            <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">{data.subtitle}</h5>
                            <h3 className="title mb-58" data-aos="fade-up" data-aos-duration="1000">{data.title}</h3>
                            <p className="fs-21 mb-33" data-aos="fade-up" data-aos-duration="1000">{data.desc1}</p>
                            <p className="fs-18 line-h17 mb-41" data-aos="fade-up" data-aos-duration="1000">{data.desc2}</p>
                            <Link to="/about" className="btn-action style-2"  data-aos="fade-up" data-aos-duration="1200">More About Me</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;